import {
  DeepRequired,
  FieldErrorsImpl,
  FieldValues,
  Path,
  UseFormRegister,
} from "react-hook-form";
import { IFileUploadProps } from "../../components/FileUpload/FileUpload";
import { useApiErrors } from "../../hooks";
import { getApiErrorsByFieldName } from "../../utils";

import { View } from "./View";

export interface IHookFormFileUploadProps<TFormValues extends FieldValues>
  extends IFileUploadProps {
  register: UseFormRegister<TFormValues>;
  errors: FieldErrorsImpl<DeepRequired<TFormValues>>;
}

export function HookFormFileUpload<TFormValues extends FieldValues>(
  props: IHookFormFileUploadProps<TFormValues>
) {
  const { arrayFieldName, arrayFieldIndex, name, errors, ...rest } = props;

  const { apiErrors } = useApiErrors();

  const controlName =
    arrayFieldName && arrayFieldIndex
      ? `${arrayFieldName}.${arrayFieldIndex}.${name}`
      : name;

  const apiErrorMessage =
    // arrayFieldName && arrayFieldIndex
    //   ? getApiErrorsByArrayFieldName(props.name, apiErrors) :
    getApiErrorsByFieldName(props.name, apiErrors);

  const hookFormErrorMessage =
    arrayFieldName && arrayFieldIndex
      ? errors[arrayFieldName] &&
        (errors[`${arrayFieldName}`] as any)[arrayFieldIndex]?.email?.message
      : errors[props.name] && errors[`${props.name}`]?.["message"];

  const combinedErrors = hookFormErrorMessage || apiErrorMessage || "";

  const hookFormProps = props.register(controlName as Path<TFormValues>);
  const { onChange: onChangeHookForm, ...restHookFormProps } = hookFormProps;

  const onChange = (e: any) => {
    props.onChange && props.onChange(e);
    onChangeHookForm(e);
  };

  return (
    <View
      {...rest}
      name={controlName}
      invalid={!!combinedErrors}
      invalidText={combinedErrors}
      onChange={onChange}
    />
  );
}
